import onboardingManager from 'onboarding/onboardingmanager';


function scheduleOnboarding (onboardingClass, trackingParams = {}, payload = {}) {
  const manager = onboardingManager;
  return manager.scheduleOnboarding(onboardingClass, trackingParams, payload);
}

export default scheduleOnboarding;
